import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Lock, Sparkles } from 'lucide-react';
export function PricingSection() {
  return;
}